module.exports = __webpack_public_path__ + "static/media/memory-preview-tutorial.0090d5c7.gif";